import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=2ba73bd2&scoped=true"
import script from "./operate.vue?vue&type=script&lang=js"
export * from "./operate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba73bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba73bd2')) {
      api.createRecord('2ba73bd2', component.options)
    } else {
      api.reload('2ba73bd2', component.options)
    }
    module.hot.accept("./operate.vue?vue&type=template&id=2ba73bd2&scoped=true", function () {
      api.rerender('2ba73bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/applet/operate.vue"
export default component.exports